// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "@media screen and (-ms-high-contrast: active){.trigger-active-3pqC3lo6mwr:focus{-webkit-transform:scale(1);transform:scale(1)}}\n", ""]);
// Exports
exports.locals = {
	"active": "trigger-active-3pqC3lo6mwr"
};
module.exports = exports;
